// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'repoHome',
        component: () => import('@/views/RepoHome.vue'),
      },
      {
        path: 'home', // 添加一级路径前缀
        redirect: '/', // 重定向到首页
        children: [
          {
            path: 'combined',
            name: 'Combined Custom',
            component: () => import('@/views/CombinedCustom.vue'),
          },
          {
            path: 'driver',
            name: 'Driver Custom',
            component: () => import('@/views/DriverCustom.vue'),
          },
          {
            path: 'hdmbioscpld',
            name: 'HDM&BIOS&CPLD Custom',
            component: () => import('@/views/HdmBiosCpldCustom.vue'),
          },
          {
            path: 'hdm',
            name: 'HDM Custom',
            component: () => import('@/views/HdmCustom.vue'),
          },
          {
            path: 'x86',
            name: 'X86_G3G5G6 Custom',
            component: () => import('@/views/X86Custom.vue'),
          },
          {
            path: 'x86g7',
            name: 'X86_G7 Custom',
            component: () => import('@/views/X86Custom.vue'),
          },
          {
            path: 'arm',
            name: 'Arm Custom',
            component: () => import('@/views/ArmCustom.vue'),
          },
          {
            path: 'om',
            name: 'OM Custom',
            component: () => import('@/views/OmCustom.vue'),
          },
          {
            path: 'managertool',
            name: 'REPO Manager Tool',
            component: () => import('@/views/ManagerTool.vue'),
          }
        ]
      }
    ]
  }
];
// 3. 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;